<template>
  <el-dialog
    title="Editar jornada"
    :visible.sync="visible"
    width="70%"
    :before-close="handleClose"
  >
    <el-form :model="resource">
      <el-form-item
        label="Empleado"
        label-width="120px"
      >{{
        resource.employee.company_id_number + " - " + resource.employee.name
      }}</el-form-item>
      <el-form-item
        label="Fecha"
        label-width="120px"
      >{{
        resource.date
      }}</el-form-item>
      <el-form-item
        label="Entrada"
        label-width="120px"
      >
        <el-row>
          <el-col :span="9">
            <drop
              class="drop"
              :class="{ over }"
              @dragover="over = true"
              @dragleave="over = false"
              @drop="handleDropOnStartTime"
            >
              <el-time-picker
                v-model="resource.start_time"
                type="fixed-time"
                placeholder="Hora"
                clearable
              >
              </el-time-picker>
            </drop>
          </el-col>
          <el-col :span="11">
            <el-radio-group
              v-model="resource.start_record_date"
              size="mini"
            >
              <el-radio-button
                v-model="resource.start_record_date"
                label="prev_day"
              >&lt; anterior</el-radio-button>
              <el-radio-button
                v-model="resource.start_record_date"
                label="same_day"
              >mismo día</el-radio-button>
              <el-radio-button
                v-model="resource.start_record_date"
                label="next_day"
              >siguiente &gt;</el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item
        label="Salida"
        label-width="120px"
      >
        <el-row>
          <el-col :span="9">
            <drop
              class="drop"
              :class="{ over }"
              @dragover="over = true"
              @dragleave="over = false"
              @drop="handleDropOnEndTime"
            >
              <el-time-picker
                v-model="resource.end_time"
                type="fixed-time"
                placeholder="Hora"
                clearable
              >
              </el-time-picker>
            </drop>
          </el-col>
          <el-col :span="11">
            <el-radio-group
              v-model="resource.end_record_date"
              size="mini"
            >
              <el-radio-button
                v-model="resource.end_record_date"
                label="prev_day"
              >&lt; anterior</el-radio-button>
              <el-radio-button
                v-model="resource.end_record_date"
                label="same_day"
              >mismo día</el-radio-button>
              <el-radio-button
                v-model="resource.end_record_date"
                label="next_day"
              >siguiente &gt;</el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item
        v-if="this.$auth.config.setCostCenterOnManualRecords || false"
        label="Centro de Costo"
        label-width="120px"
        prop="cost_center_id"
      >
        <el-select
          v-model="resource.cost_center_id"
          filterable
          clearable
          placeholder="Centro de Costo"
        >
          <el-option
            v-for="item in cost_centers"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <div>
        <h4>Registros disponibles</h4>
        <el-row :gutter="10">
          <el-col :span="8">
            <h5>Día anterior</h5>
            <div
              v-for="record in resource.prev_records"
              :key="record.D + record.date + record.T"
              class="record-item"
            >
              <drag
                class="drag"
                :transfer-data="record"
              >
                <span>{{ `${record.prefix}${record.T} - ${getDeviceName(record)}` }}</span>
              </drag>
              <div class="record-actions">
                <el-tag size="mini" :type="isManualRecord(record) ? 'warning' : 'success'">
                  {{ isManualRecord(record) ? 'Manual' : 'Automática' }}
                </el-tag>
                <el-button
                  v-if="isManualRecord(record)"
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  style="padding: 3px; margin-left: 4px;"
                  title="Eliminar marca manual"
                  @click.stop="handleDeleteSingleRecord(record)"
                ></el-button>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <h5>Mismo día</h5>
            <div
              v-for="record in resource.records"
              :key="record.D + record.date + record.T"
              class="record-item"
            >
              <drag
                class="drag"
                :transfer-data="record"
              >
                <span>{{ `${record.prefix}${record.T} - ${getDeviceName(record)}` }}</span>
              </drag>
              <div class="record-actions">
                <el-tag size="mini" :type="isManualRecord(record) ? 'warning' : 'success'">
                  {{ isManualRecord(record) ? 'Manual' : 'Automática' }}
                </el-tag>
                <el-button
                  v-if="isManualRecord(record)"
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  style="padding: 3px; margin-left: 4px;"
                  title="Eliminar marca manual"
                  @click.stop="handleDeleteSingleRecord(record)"
                ></el-button>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <h5>Día siguiente</h5>
            <div
              v-for="record in resource.next_records"
              :key="record.D + record.date + record.T"
              class="record-item"
            >
              <drag
                class="drag"
                :transfer-data="record"
              >
                <span>{{ `${record.prefix}${record.T} - ${getDeviceName(record)}` }}</span>
              </drag>
              <div class="record-actions">
                <el-tag size="mini" :type="isManualRecord(record) ? 'warning' : 'success'">
                  {{ isManualRecord(record) ? 'Manual' : 'Automática' }}
                </el-tag>
                <el-button
                  v-if="isManualRecord(record)"
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  style="padding: 3px; margin-left: 4px;"
                  title="Eliminar marca manual"
                  @click.stop="handleDeleteSingleRecord(record)"
                ></el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="danger"
        icon="el-icon-delete"
        style="float: left;"
        @click="handleDeleteOverride"
      >Eliminar jornada manual</el-button>
      <el-button @click="handleClose">Cancelar</el-button>
      <el-button
        type="primary"
        @click="handleSubmit"
      >Confirmar</el-button>
    </span>
  </el-dialog>
</template>

<style>
table.details td {
  padding-left: 3px;
  padding-right: 3px;
  font-size: 11px;
  line-height: 1.3em;
  height: 15px;
}
.drop.over {
  border-color: #aaa;
  background: #ccc;
}
.drag {
  cursor: grab;
  font-size: 12px;
}
.record-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  padding: 4px 6px;
  background: #fdfdfd;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
}
.record-actions {
  display: flex;
  align-items: center;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import { getOptionLabel } from "../../utils/lib";
import { Drag, Drop } from "vue-drag-drop";

export default {
  name: "workday-edit",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      // devices: {},
      baseUrl: "/reports/dailyattendancedetails",
      resource: {
        computed: null,
        prev_records: null,
        records: null,
        next_records: null,
        start_time: null,
        end_time: null,
        employee: {
          id: null,
          company_id_number: null,
          name: null,
        },
        date: null,
        start_record_date: "same_day",
        end_record_date: "same_day",
        cost_center_id: null,
      },
      over: false,
      edit: false,
    };
  },
  computed: {
    ...mapGetters(["devices_key_value", "cost_centers"]),
  },
  mounted() {
    this.fetchDevices();
    this.fetchCostCenters();
  },
  components: {
    Drag,
    Drop,
  },
  methods: {
    ...mapActions(["fetchDevices", "fetchCostCenters"]),
    handleEdit: function (index, row) {
      this.resource.prev_records = [];
      this.resource.records = [{ prefix: "- ", T: "Cargando...", D: null }];
      this.resource.next_records = [];
      this.resource.employee = this.data.employee;
      this.resource.date = this.data.date;
      this.resource.computed = this.data.computed;

      this.resource.start_record_date = "same_day";
      if (
        this.resource.computed.in !== undefined &&
        this.resource.computed.in !== null
      ) {
        if (this.resource.computed.in.indexOf("(-1)") === 0) {
          this.resource.start_record_date = "prev_day";
          this.resource.start_time = new Date(
            this.resource.date + " " + this.resource.computed.in.substring(5)
          );
          this.resource.start_time.setDate(
            this.resource.start_time.getDate() - 1
          );
        } else if (this.resource.computed.in.indexOf("(+1)") === 0) {
          this.resource.start_record_date = "next_day";
          this.resource.start_time = new Date(
            this.resource.date + " " + this.resource.computed.in.substring(5)
          );
          this.resource.start_time.setDate(
            this.resource.start_time.getDate() + 1
          );
        } else {
          this.resource.start_time = new Date(
            this.resource.date + " " + this.resource.computed.in
          );
        }
      } else {
        this.resource.start_time = null;
      }
      this.resource.end_record_date = "same_day";
      if (
        this.resource.computed.out !== undefined &&
        this.resource.computed.out !== null
      ) {
        if (this.resource.computed.out.indexOf("(+1)") === 0) {
          this.resource.end_record_date = "next_day";
          this.resource.end_time = new Date(
            this.resource.date + " " + this.resource.computed.out.substring(5)
          );
          this.resource.end_time.setDate(this.resource.end_time.getDate() + 1);
        } else if (this.resource.computed.out.indexOf("(-1)") === 0) {
          this.resource.end_record_date = "prev_day";
          this.resource.end_time = new Date(
            this.resource.date + " " + this.resource.computed.out.substring(5)
          );
          this.resource.end_time.setDate(this.resource.end_time.getDate() - 1);
        } else {
          this.resource.end_time = new Date(
            this.resource.date + " " + this.resource.computed.out
          );
        }
      } else {
        this.resource.end_time = null;
      }

      this.fetchModalRecords();
      this.edit = true;
    },
    fetchModalRecords: function () {
      const prev_date = moment(this.resource.date)
        .subtract(1, "days")
        .format("YYYY-MM-DD");
      const next_date = moment(this.resource.date)
        .add(1, "days")
        .format("YYYY-MM-DD");

      axios
        .get(
          "/api/employees/" +
          this.resource.employee.id +
          "/records?direction=desc&get_all_records=true&date_from=" +
          prev_date +
          "&date_to=" +
          next_date
        )
        .then((response) => {
          let prev_rec = [];
          let rec = [];
          let next_rec = [];
          _.each(response.data, (record) => {
            let addedTimes = new Set();

            _.each(record.raw, (entry) => {
              let timeOnly = entry.T;
              if (timeOnly && timeOnly.length > 8) {
                timeOnly = timeOnly.substring(11);
              }
              let entryItem = Object.assign({}, entry, {
                date: record.date,
                T: timeOnly
              });
              addedTimes.add(timeOnly);
              if (record.date === this.resource.date) {
                entryItem["prefix"] = "";
                rec.push(entryItem);
              } else if (record.date > this.resource.date) {
                entryItem["prefix"] = "(+1)";
                next_rec.push(entryItem);
              } else {
                entryItem["prefix"] = "(-1)";
                prev_rec.push(entryItem);
              }
            });

            if (record.override) {
              if (record.override.in) {
                let inStr = String(record.override.in);
                let inDate = inStr.length >= 10 ? inStr.substring(0, 10) : record.date;
                let inTime = inStr.length >= 19 ? inStr.substring(11, 19) : (inStr.length <= 8 ? inStr : inStr.substring(11));
                if (inTime && !addedTimes.has(inTime)) {
                  addedTimes.add(inTime);
                  let manualEntry = {
                    date: inDate,
                    T: inTime,
                    D: 999,
                    is_manual: true,
                    prefix: (inDate === this.resource.date) ? "" : ((inDate > this.resource.date) ? "(+1)" : "(-1)")
                  };
                  if (inDate === this.resource.date) rec.push(manualEntry);
                  else if (inDate > this.resource.date) next_rec.push(manualEntry);
                  else prev_rec.push(manualEntry);
                }
              }
              if (record.override.out) {
                let outStr = String(record.override.out);
                let outDate = outStr.length >= 10 ? outStr.substring(0, 10) : record.date;
                let outTime = outStr.length >= 19 ? outStr.substring(11, 19) : (outStr.length <= 8 ? outStr : outStr.substring(11));
                if (outTime && !addedTimes.has(outTime)) {
                  addedTimes.add(outTime);
                  let manualEntry = {
                    date: outDate,
                    T: outTime,
                    D: 999,
                    is_manual: true,
                    prefix: (outDate === this.resource.date) ? "" : ((outDate > this.resource.date) ? "(+1)" : "(-1)")
                  };
                  if (outDate === this.resource.date) rec.push(manualEntry);
                  else if (outDate > this.resource.date) next_rec.push(manualEntry);
                  else prev_rec.push(manualEntry);
                }
              }
            }
          });

          this.resource.prev_records = prev_rec;
          this.resource.records = rec;
          this.resource.next_records = next_rec;
        });
    },
    handleDropOnStartTime: function (data) {
      // console.log(data);
      this.over = false;
      // if (data.date !== this.resource.date) {
      //     alert("Sólo puedes elegir un registro de la fecha actual.");
      //     return;
      // }
      // this.resource.start_time = new Date(this.resource.date + ' ' + data.T);
      this.resource.start_time = new Date(data.date + " " + data.T);
      this.resource.start_record_date =
        data.date === this.resource.date
          ? "same_day"
          : data.date < this.resource.date
            ? "prev_day"
            : "next_day";
    },
    handleDropOnEndTime: function (data) {
      // console.log(data);
      this.over = false;
      this.resource.end_time = new Date(data.date + " " + data.T);
      this.resource.end_record_date =
        data.date === this.resource.date
          ? "same_day"
          : data.date < this.resource.date
            ? "prev_day"
            : "next_day";
    },
    handleSubmit: function () {
      // console.log(this.resource);
      //   this.dialogFormVisible = false
      // self = this;
      //   this.clearErrors();
      // console.log(this.resource);
      let res = {
        date: this.resource.date,
      };
      if (this.resource.start_time !== null) {
        // res['in'] = moment(this.resource.start_time).year(this.resource.date.substring(0, 4)).month(this.resource.date.substring(5, 7) - 1).date(this.resource.date.substring(8, 10)).format("YYYY-MM-DD HH:mm:ss");
        let _in = moment(this.resource.start_time);
        if (this.resource.start_record_date === "prev_day") {
          _in
            .year(this.resource.date.substring(0, 4))
            .month(this.resource.date.substring(5, 7) - 1)
            .date(this.resource.date.substring(8, 10))
            .subtract(1, "days");
          // console.log("next_day");
        } else if (this.resource.start_record_date === "next_day") {
          _in
            .year(this.resource.date.substring(0, 4))
            .month(this.resource.date.substring(5, 7) - 1)
            .date(this.resource.date.substring(8, 10))
            .add(1, "days");
          // console.log("next_day");
        } else {
          // console.log("same_day");
          _in
            .year(this.resource.date.substring(0, 4))
            .month(this.resource.date.substring(5, 7) - 1)
            .date(this.resource.date.substring(8, 10));
        }
        // console.log(in);
        res["in"] = _in.format("YYYY-MM-DD HH:mm:ss");
      }
      if (this.resource.end_time !== null) {
        let out = moment(this.resource.end_time);
        if (this.resource.end_record_date === "prev_day") {
          out
            .year(this.resource.date.substring(0, 4))
            .month(this.resource.date.substring(5, 7) - 1)
            .date(this.resource.date.substring(8, 10))
            .subtract(1, "days");
          // console.log("next_day");
        } else if (this.resource.end_record_date === "next_day") {
          out
            .year(this.resource.date.substring(0, 4))
            .month(this.resource.date.substring(5, 7) - 1)
            .date(this.resource.date.substring(8, 10))
            .add(1, "days");
          // console.log("next_day");
        } else {
          // console.log("same_day");
          out
            .year(this.resource.date.substring(0, 4))
            .month(this.resource.date.substring(5, 7) - 1)
            .date(this.resource.date.substring(8, 10));
        }
        // console.log(out);
        res["out"] = out.format("YYYY-MM-DD HH:mm:ss");
      }
      if (this.resource.cost_center_id !== null) {
        res["cost_center_id"] = this.resource.cost_center_id;
      }
      // console.log(res);
      axios
        .post(
          "/api/employees/" + this.resource.employee.id + "/recordsoverride",
          res
        )
        .then((response) => {
          // console.log(response);
          // this.$router.push(self.baseUrl);
          // this.dialogFormVisible = false;
          // this.addRecordDialogFormVisible = false;
          // this.$refs.dataTable.fetchItems();
          this.$emit("workdayEdited");
        })
        .catch((error) => {
          if (error.response.status == 422) {
            _.each(error.response.data, (value, key) => {
              this.errors[key] = value.join(", ");
            });
          }
        });
    },
    handleClose: function () {
      this.$emit("close");
    },
    handleDeleteOverride: function () {
      this.$confirm(
        "¿Está seguro de que desea eliminar la jornada manual para el empleado " +
          this.resource.employee.name +
          " en la fecha " +
          this.resource.date +
          "?",
        "Confirmar eliminación",
        {
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      )
        .then(() => {
          axios
            .post(
              "/api/employees/" +
                this.resource.employee.id +
                "/recordsoverride",
              {
                date: this.resource.date,
              }
            )
            .then((response) => {
              this.$message({
                type: "success",
                message: "Jornada manual eliminada correctamente.",
              });
              this.$emit("workdayEdited");
            })
            .catch((error) => {
              let msg = "Error al eliminar la jornada manual.";
              if (
                error.response &&
                error.response.data &&
                error.response.data.message
              ) {
                msg = error.response.data.message;
              }
              this.$message({
                type: "error",
                message: msg,
              });
            });
        })
        .catch(() => {});
    },
    isManualRecord: function (record) {
      if (!record) return false;
      if (record.is_manual) return true;
      if (record.D === null || record.D === undefined) return false;
      const dev = String(record.D);
      if (dev === "999" || dev === "ADDED_IN_RECORD" || dev === "ADDED_OUT_RECORD" || dev === "MANUAL") {
        return true;
      }
      const label = this.devices_key_value[record.D];
      if (label && (label.toLowerCase().includes("manual") || label.toLowerCase().includes("agregado"))) {
        return true;
      }
      return false;
    },
    getDeviceName: function (record) {
      if (!record) return "";
      const label = this.devices_key_value[record.D];
      if (label) return label;
      if (this.isManualRecord(record)) return "Manual";
      return record.D ? String(record.D) : "";
    },
    handleDeleteSingleRecord: function (record) {
      const typeText = this.isManualRecord(record) ? "Manual" : "Automática";
      const devName = this.getDeviceName(record);
      this.$confirm(
        "¿Está seguro de que desea eliminar la marca " +
          typeText +
          " (" +
          record.T +
          " - " +
          devName +
          ") del día " +
          record.date +
          "?",
        "Confirmar eliminación",
        {
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      )
        .then(() => {
          axios
            .post(
              "/api/employees/" +
                this.resource.employee.id +
                "/records/delete-entry",
              {
                date: record.date,
                time: record.T,
                device_id: record.D,
              }
            )
            .then((response) => {
              this.$message({
                type: "success",
                message: "Registro eliminado correctamente.",
              });
              this.$emit("workdayEdited");
            })
            .catch((error) => {
              let msg = "Error al eliminar el registro.";
              if (
                error.response &&
                error.response.data &&
                error.response.data.message
              ) {
                msg = error.response.data.message;
              }
              this.$message({
                type: "error",
                message: msg,
              });
            });
        })
        .catch(() => {});
    },
  },
};
</script>
